import { BuyerCancelRow, PayMode, PayModeBucket } from 'services/reportsApi';

export interface CancellationsSummary {
  count: number;
  total_amount: number;
  by_pay_mode: Partial<Record<PayMode, PayModeBucket>>;
}

const toAmount = (raw: string): number => {
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
};

export const summarizeCancellations = (rows: BuyerCancelRow[]): CancellationsSummary => {
  const summary: CancellationsSummary = {
    count: 0,
    total_amount: 0,
    by_pay_mode: {},
  };
  for (const row of rows) {
    const amount = toAmount(row.amount);
    summary.count += 1;
    summary.total_amount += amount;
    const bucket =
      summary.by_pay_mode[row.pay_mode] ??
      (summary.by_pay_mode[row.pay_mode] = { count: 0, total_amount: 0 });
    bucket.count += 1;
    bucket.total_amount += amount;
  }
  return summary;
};

export const uniqueProperties = (rows: BuyerCancelRow[]): Array<{ id: string; name: string }> => {
  const seen = new Map<string, string>();
  for (const row of rows) {
    if (!seen.has(row.property_id)) {
      seen.set(row.property_id, row.property_name ?? 'Unknown property');
    }
  }
  return Array.from(seen.entries())
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
};
